module.exports = __webpack_public_path__ + "assets/decorazione_necrologio.4e3cedc5.svg";